import React, { useEffect } from 'react';
import CustomTab from "../../components/ui/CustomTab";
import { useDispatch } from 'react-redux';
import { pushRoute, setSaveDashboardFormState } from '../../store/globalSlice';

const tabs = [
	{
		label: "Customer Rename",
		to: "Customer_Rename",
		value: "/functionaladmin/Customer_Rename",
	},
	// {
	// 	label: "Relationship Level",
	// 	to: "Customer_Trust_Level",
	// 	value: "/functionaladmin/Customer_Trust_Level",
	// },
	{
		label: "SKU Replacement",
		to: "SKU_Replacement",
		value: "/functionaladmin/SKU_Replacement",
	},
  	{
		label: "Edit Scenario",
		to: "Edit_Scenario",
		value: "/functionaladmin/Edit_Scenario",
	},
	
];

const FunctionalAdmin = () => {
  const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setSaveDashboardFormState(false));
      dispatch(pushRoute("functional-admin"));
    }, []);
  return (
    <CustomTab tabs={tabs} />
  )
}

export default FunctionalAdmin